/* ==========================================================================
   ZORA — Quick view
   Fetches the product rendered by the zora-quick-view section and shows it in
   a modal. Server-rendered, so prices and availability are always real.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, r) {
    return (r || document).querySelector(s);
  }
  function $$(s, r) {
    return Array.prototype.slice.call((r || document).querySelectorAll(s));
  }
  function money(cents) {
    if (window.Zora && window.Zora.formatMoney) return window.Zora.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  var modal = null;
  var body = null;
  var lastTrigger = null;
  var cache = {};

  /* ----------------------------------------------------------------------
     The shell is built once, on first use
     ---------------------------------------------------------------------- */
  function ensureModal() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'z-modal z-modal--qv';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="z-modal__scrim" data-z-qv-close></div>' +
      '<div class="z-modal__panel" role="dialog" aria-modal="true" aria-label="Quick view">' +
      '<button type="button" class="z-modal__close" data-z-qv-close aria-label="Close">' +
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button>' +
      '<div class="z-modal__body" data-z-qv-body>' +
      '<div class="z-qv__loading"><span></span><span></span><span></span></div>' +
      '</div></div>';

    document.body.appendChild(modal);
    body = $('[data-z-qv-body]', modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-z-qv-close]')) close();
    });

    return modal;
  }

  function open(trigger) {
    lastTrigger = trigger;
    ensureModal();
    modal.removeAttribute('hidden');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
    document.body.classList.add('z-locked');
    var closeBtn = $('[data-z-qv-close].z-modal__close', modal);
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 80);
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('z-locked');
    setTimeout(function () {
      modal.setAttribute('hidden', '');
      if (body) body.innerHTML = '<div class="z-qv__loading"><span></span><span></span><span></span></div>';
    }, 320);
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  function load(url) {
    var endpoint = url.split('?')[0] + '?section_id=zora-quick-view';

    if (cache[endpoint]) {
      inject(cache[endpoint]);
      return;
    }

    fetch(endpoint)
      .then(function (r) {
        if (!r.ok) throw new Error('unavailable');
        return r.text();
      })
      .then(function (html) {
        cache[endpoint] = html;
        inject(html);
      })
      .catch(function () {
        // If quick view can't load, the product page still can
        window.location.href = url;
      });
  }

  function inject(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var content = doc.querySelector('[data-z-qv]');
    if (!content || !body) return;

    body.innerHTML = '';
    body.appendChild(document.importNode(content, true));

    bind(body);
    if (window.Zora && window.Zora.initAll) window.Zora.initAll(body);
  }

  /* ----------------------------------------------------------------------
     Wire up the injected markup
     ---------------------------------------------------------------------- */
  function bind(scope) {
    var root = $('[data-z-qv]', scope);
    if (!root) return;

    /* ---- gallery thumbs ---- */
    var images = $$('[data-z-qv-img]', root);
    $$('[data-z-qv-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-media-id');
        images.forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-media-id') === id);
        });
        $$('[data-z-qv-thumb]', root).forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });

    /* ---- variants ---- */
    var dataEl = $('[data-z-variant-data]', root);
    var idInput = $('[data-z-qv-variant-id]', root);
    var priceCurrent = $('[data-z-qv-price-current]', root);
    var priceCompare = $('[data-z-qv-price-compare]', root);
    var addBtn = $('[data-z-qv-add]', root);
    var addText = $('[data-z-qv-add-text]', root);
    var wishBtn = $('[data-z-wishlist-toggle]', root);
    var variants = [];

    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        variants = [];
      }
    }

    function selected() {
      return $$('.z-variant', root).map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function refreshAvailability(opts) {
      $$('.z-variant', root).forEach(function (fs, axis) {
        $$('.z-variant__pill', fs).forEach(function (pill) {
          var probe = opts.slice();
          probe[axis] = pill.getAttribute('data-value');
          var reachable = variants.some(function (v) {
            return (
              v.available &&
              probe.every(function (o, i) {
                return o === null || v.options[i] === o;
              })
            );
          });
          pill.classList.toggle('is-unavailable', !reachable);
        });
      });
    }

    function update() {
      var opts = selected();
      refreshAvailability(opts);

      var variant = variants.find(function (v) {
        return opts.every(function (o, i) {
          return o === null || v.options[i] === o;
        });
      });

      $$('.z-variant', root).forEach(function (fs, i) {
        var out = fs.querySelector('[data-z-variant-selected]');
        if (out && opts[i]) out.textContent = opts[i];
      });

      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceCurrent) priceCurrent.textContent = money(variant.price);

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceCompare) {
        priceCompare.textContent = onSale ? money(variant.compare_at_price) : '';
        priceCompare.toggleAttribute('hidden', !onSale);
      }

      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) {
        addText.textContent = variant.available
          ? addText.getAttribute('data-add') || 'Add to cart'
          : addText.getAttribute('data-sold-out') || 'Sold out';
      }

      if (wishBtn) {
        wishBtn.setAttribute('data-variant-id', variant.id);
        wishBtn.setAttribute('data-price', money(variant.price));
      }

      // Swap to the variant's own image if it has one
      if (variant.featured_media_id) {
        var target = String(variant.featured_media_id);
        $$('[data-z-qv-img]', root).forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-media-id') === target);
        });
        $$('[data-z-qv-thumb]', root).forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-media-id') === target);
        });
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) update();
    });

    refreshAvailability(selected());

    /* ---- add to cart ---- */
    var form = $('[data-z-qv-form]', root);
    var errorEl = $('[data-z-qv-error]', root);

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!addBtn || addBtn.disabled) return;

        if (errorEl) {
          errorEl.setAttribute('hidden', '');
          errorEl.textContent = '';
        }

        var original = addText ? addText.textContent : '';
        addBtn.disabled = true;
        if (addText) addText.textContent = 'Adding…';

        var formData = new FormData(form);
        var sections = [];
        if (document.querySelector('cart-drawer')) sections.push('cart-drawer');
        if (document.querySelector('cart-notification')) sections.push('cart-notification');
        if (document.querySelector('#cart-icon-bubble')) sections.push('cart-icon-bubble');
        if (sections.length) {
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
        }

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: formData,
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            if (data.status) throw new Error(data.description || data.message || 'Could not add to cart');
            if (window.Zora && window.Zora.renderCartSections) window.Zora.renderCartSections(data.sections);
            if (window.Zora && window.Zora.toast) {
              window.Zora.toast('Added to your cart', {
                href: (window.routes && window.routes.cart_url) || '/cart',
                linkText: 'View cart',
              });
            }
            close();
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.textContent = err.message;
              errorEl.removeAttribute('hidden');
            }
            if (addText) addText.textContent = original;
          })
          .finally(function () {
            addBtn.disabled = false;
          });
      });
    }
  }

  /* ----------------------------------------------------------------------
     Triggers
     ---------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-z-quickview]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();

    var url = trigger.getAttribute('data-product-url');
    if (!url) return;

    open(trigger);
    load(url);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) close();
  });

  // Keep focus inside the dialog
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !modal || modal.hasAttribute('hidden')) return;
    var panel = $('.z-modal__panel', modal);
    if (!panel) return;
    var items = $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) {
        return el.offsetParent !== null;
      });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();
